<div class="textRecordsContainer">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
    <div class="loader" *ngIf="bodySpinner"></div>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Create Contract</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div>
     <div class="container-fluid">
        <div id="contractwrapper">
            <div class="row">
                <div class="col">Company Name</div>
                <div class="col"><select><option>Select</option></select></div>
            </div>
            <div class="row">
                <div class="col">Company Relationship</div>
                <div class="col"><select><option>Select</option><option>Vendor</option><option>Customer</option><option>Supplier</option></select></div>
            </div>
            <div class="row">
                <div class="col">Contract Type</div>
                <div class="col">
                    <select><option>Select</option><option>NDA</option><option>ASA</option>
                <option>DPA</option><option>MSA</option><option>Exit</option><option>DSA</option><option>Indemnification</option></select>
                </div>
            </div>
            <div class="row">
                <div class="col">Contract Value</div>
                <div class="col"><input type="text" ></div>
            </div>
            <div class="row">
                <div class="col">Effective Date</div>
                <div class="col"> <span class="date-wrapper">
                    <span class="icon"><i class="fa-regular fa-calendar-days"></i></span>
                    <input type="text" class="form-control datepicker" 
                    ngxDaterangepickerMd [autoApply]="true" [(ngModel)]="selectedDate" [showDropdowns]="true" placeholder="MM/DD/YYYY" [singleDatePicker]="true" [locale]="{format: 'MM/DD/YYYY'}"
                    (change)="getDateSearchData($event)" [readonly]="true" /> 
                 </span></div>
            </div>
            <div class="row">
                <div class="col">Payment Terms</div>
                <div class="col"><textarea></textarea></div>
            </div>
            <div class="row">
                <div class="col">Termination Period</div>
                <div class="col"><input type="text" ></div>
            </div>
            <div class="row">
                <div class="col">Termination Date</div>
                <div class="col"> <span class="date-wrapper">
                    <span class="icon"><i class="fa-regular fa-calendar-days"></i></span>
                    <input type="text" class="form-control datepicker" 
                    ngxDaterangepickerMd [autoApply]="true" [(ngModel)]="terminateDate" [showDropdowns]="true" placeholder="MM/DD/YYYY" [singleDatePicker]="true" [locale]="{format: 'MM/DD/YYYY'}"
                    (change)="getDateSearchData($event)" [readonly]="true" /> 
                 </span></div>
            </div>
            <div class="row">
                <div class="col">Termination Notice Period</div>
                <div class="col"><input type="text"></div>
            </div>
            <div class="row">
                <div class="col">Signing Person1 Name</div>
                <div class="col"><input type="text"></div>
            </div>
            <div class="row">
                <div class="col">Signing Person1 Title</div>
                <div class="col"><input type="text"></div>
            </div>
            <div class="row">
                <div class="col">Signing Person2 Name</div>
                <div class="col"><input type="text"></div>
            </div>
            <div class="row">
                <div class="col">Signing Person2 Title</div>
                <div class="col"><input type="text"></div>
            </div>
             <div class="row">
                <div class="col">Assign To</div>
                <div class="col"><select><option>Select</option></select></div>
            </div>
            <div class="row">
                <div class="col"></div>
                <div class="col"><button class="btn btn-primary audioTableSearchBtn">Save</button></div>
            </div>
        </div>
     </div>
</div>            